// extracted by mini-css-extract-plugin
export default {"btn-language":"LanguageSwitcher_btn-language__udAOz","flag":"LanguageSwitcher_flag__oHXSR"};